(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dt-shows"] && !Shopify.designMode) return;
  try {
    
function initializeShows(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const upcoming=root.querySelector('[data-upcoming]'),past=root.querySelector('[data-past-list]');
  const cards=Array.from(root.querySelectorAll('.dt-show')).reverse().sort((a,b)=>Date.parse(a.dataset.start)-Date.parse(b.dataset.start));
  const seen=new Set();
  const utc=value=>new Date(value).toISOString().replace(/[-:]/g,'').replace(/\.\d{3}Z$/,'Z');
  const escapeICS=value=>value.replace(/\\/g,'\\\\').replace(/\r?\n/g,'\\n').replace(/,/g,'\\,').replace(/;/g,'\\;');
  const fold=line=>{let result='',bytes=0;for(const char of line){const n=new TextEncoder().encode(char).length;if(bytes+n>75){result+='\r\n ';bytes=1;}result+=char;bytes+=n;}return result;};
  for(const card of cards){
    for(const day of card.querySelectorAll('[data-day]')){
      const local=value=>new Date(value.slice(0,19)+'Z');
      const date=value=>local(value).toLocaleDateString('en-US',{weekday:'long',year:'numeric',month:'long',day:'numeric',timeZone:'UTC'});
      const time=value=>local(value).toLocaleTimeString('en-US',{hour:'numeric',minute:'2-digit',timeZone:'UTC'});
      if(!day.dataset.start.includes('T00:00:00'))day.textContent=date(day.dataset.start)+': '+time(day.dataset.start)+(day.dataset.end?' to '+(day.dataset.end.slice(0,10)!==day.dataset.start.slice(0,10)?date(day.dataset.end)+' ':'')+time(day.dataset.end):'');
      else if(day.dataset.end&&day.dataset.end.slice(0,10)!==day.dataset.start.slice(0,10))day.querySelector('time').textContent=date(day.dataset.start)+' to '+date(day.dataset.end);
    }
    const key=card.dataset.city.toLowerCase()+'|'+card.dataset.start;
    if(seen.has(key)){card.remove();continue;}seen.add(key);
    let finish=Date.parse(card.dataset.end);
    if(!Number.isFinite(finish)){const day=card.dataset.start.slice(0,10);const offset=card.dataset.start.slice(19)||'Z';finish=Date.parse(day+'T23:59:59'+offset);}
    const expired=finish<Date.now();(expired?past:upcoming).append(card);
    if(expired||['Cancelled by organizer','Postponed'].includes(card.dataset.status))continue;
    const calendar=card.querySelector('[data-calendar]');
    const title=card.querySelector('[data-title]').textContent.trim();
    const location=card.querySelector('[data-address]').textContent.trim();
    const description=card.querySelector('[data-participation]').textContent.trim()+'\n'+window.location.origin+'/pages/model-train-shows';
    const days=Array.from(card.querySelectorAll('[data-day]')).filter(day=>day.dataset.end&&Date.parse(day.dataset.end)>Date.parse(day.dataset.start)&&!day.dataset.start.includes('T00:00:00'));
    for(const [index,day] of days.entries()){
      const suffix=days.length>1?' ('+(index+1)+')':'';
      const google=document.createElement('a');google.textContent=calendar.dataset.google+suffix;
      const query=new URLSearchParams({action:'TEMPLATE',text:title,dates:utc(day.dataset.start)+'/'+utc(day.dataset.end),details:description,location});
      google.href='https://calendar.google.com/calendar/render?'+query;google.target='_blank';google.rel='noopener';calendar.append(google);
      const lines=['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//Davids Trains//Shows//EN','CALSCALE:GREGORIAN','BEGIN:VEVENT','UID:'+card.dataset.handle+'-'+index+'@davidstrains.com','DTSTAMP:'+utc(new Date()),'DTSTART:'+utc(day.dataset.start),'DTEND:'+utc(day.dataset.end),'SUMMARY:'+escapeICS(title),'LOCATION:'+escapeICS(location),'DESCRIPTION:'+escapeICS(description),'END:VEVENT','END:VCALENDAR'];
      const ics=document.createElement('a');ics.textContent=calendar.dataset.ics+suffix;ics.download=card.dataset.handle+'-'+(index+1)+'.ics';ics.href=URL.createObjectURL(new Blob([lines.map(fold).join('\r\n')+'\r\n'],{type:'text/calendar;charset=utf-8'}));calendar.append(ics);
    }
    calendar.hidden=!days.length;
  }
  root.querySelector('[data-past]').hidden=!past.children.length;
}
document.querySelectorAll('.dt-shows').forEach(initializeShows);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.dt-shows').forEach(initializeShows));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
